import schema, { generateType, } from './Schema';
export const EngagementFlow = generateType(schema.getModel('engagementFlow'));
export const ConditionTypes = [
    {
        key: 'activity',
        label: 'Activity',
        isSelectable: false,
        subTypes: [
            {
                key: 'courseProgramMicrocast',
                label: 'Course / Program / Microcast',
                isSelectable: true,
            },
            {
                key: 'membership',
                label: 'Membership',
                isSelectable: true,
            },
            {
                key: 'purchases',
                label: 'Purchases',
                isSelectable: true,
            },
            {
                key: 'account',
                label: 'Account',
                isSelectable: true,
            },
        ],
    },
    {
        key: 'time',
        label: 'Time',
        isSelectable: true,
    },
    {
        key: 'target',
        label: 'Customer Target',
        isSelectable: true,
    },
    {
        key: 'noProgress',
        label: 'No Progress',
        isSelectable: true,
    },
    {
        key: 'learningBoard',
        label: 'Learning Board',
        isSelectable: true,
    },
    {
        key: 'accountCreated',
        label: 'Account Created',
        isSelectable: true,
    },
];
export const ConditionActivities = [
    {
        key: 'started',
        label: 'Started a Course / Program / Microcast',
        types: ['courseProgramMicrocast'],
    },
    {
        key: 'notStarted',
        label: 'Not Started a Course / Program / Microcast',
        types: ['courseProgramMicrocast'],
    },
    {
        key: 'finished',
        label: 'Finished a Course / Program / Microcast',
        types: ['courseProgramMicrocast'],
    },
    {
        key: 'notFinished',
        label: 'Not Finished a Course / Program / Microcast',
        types: ['courseProgramMicrocast'],
    },
    {
        key: 'waitFor',
        label: 'Wait For',
        types: ['time'],
    },
    {
        key: 'calendarDate',
        label: 'Date',
        types: ['time'],
    },
    {
        key: 'memberOf',
        label: 'Member Of',
        types: ['target'],
    },
    {
        key: 'purchasers',
        label: 'Purchasers',
        types: ['target'],
    },
    {
        key: 'lead',
        label: 'Lead',
        types: ['target'],
    },
    {
        key: 'purchasedMembership',
        label: 'Purchased Membership',
        types: ['membership'],
    },
    {
        key: 'purchasedMembership',
        label: 'Purchased Membership',
        types: ['membership'],
    },
    {
        key: 'progress',
        label: 'Progress on Course / Program',
        types: ['courseProgramMicrocast'],
    },
    {
        key: 'notViewedFor',
        label: 'Not Viewed For',
        types: ['learningBoard'],
    },
];
//# sourceMappingURL=EngagementFlowModel.js.map